// extracted by mini-css-extract-plugin
module.exports = {"lang":"j3","langWrap":"j4","item":"j5","itemCurrent":"j6"};